<style scoped="scoped" lang="scss">
/deep/.el-dialog .el-dialog__body {
  //max-height: calc(86vh - 112px);
  padding: 0 0 40px 66px;
}
/deep/ .dialog-scroller {
  overflow: auto;
  position: relative;
  height: calc(80vh - 550px);
}

.production-monthly {

  .panel {
    color: #419FFF;
    display: flex;
    justify-content: flex-end;
    margin-top: -33px
  }

  // 效率表单
  .form {
    margin-top: 17px;

    // 标记点
    .percent-box {
      margin-top: 8px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      min-width: 1000px;
      flex-wrap: wrap;

      .percent-input {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
      }

      .percent-input1 {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin-left: 35px;
      }

      .border {
        // border: 1px solid #E5E5E5;
        width: 60px;
        height: 28px;
        border-radius: 5px;
        margin-left: 12px;
        text-align: center;
      }

      .mark {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
      }

      .border:focus {
        outline: none;
        border: 1px solid rgb(65, 159, 255);
      }

      .text-word {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
        margin-left: 26px;
      }

      .percent {
        display: flex;
        flex-wrap: nowrap;
        color: #4d4d4d;
        margin-left: 12px;
      }
    }
  }

  // 详细指标
  .detail-target {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419FFF;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        //margin-left: 12px;
      }
    }

    // 右侧
    .right {
      display: flex;
      align-items: center;
    }
  }

  // 图表和表格
  .echart-table {
    margin-top: 8px;
    margin-bottom: 119px;
  }

  // 产品详情
  .production-detail {
    width: 100%;
    padding-left: 40px;
    // padding-right: 40px;
    color: #808184;
    margin-bottom: 34px;

    // 设备信息
    .equip-info {
      width: 40%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #606266;
    }

    // 时间信息
    .time-info {
      width: 70%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;

      .item {
        flex: 1;
        display: flex;
        flex-direction: column;

        .title {
          width: 100;
          height: 50%;
          padding: 10px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          // margin-bottom: 15px;
          margin-left: -22px;

          .sign {
            position: static;
            width: 5px;
            height: 16px;
            left: 0px;
            top: 3px;
            // background: #419FFF;
            flex: none;
            order: 0;
            flex-grow: 0;
            margin: 0px 12px;
          }

          .txt {
            font-size: 14px;
            font-family: Microsoft YaHei UI;
            line-height: 22px;
            color: #303133;
          }
        }

        .num {
          width: 100%;
          height: 50%;
          color: #808184;
          font-size: 20px;
          line-height: 20px;
          font-weight: bold;
          margin-left: 15px;
        }
      }

      .color-green {
        background: #64C136;
      }

      .color-orange {
        background: #E49D31;
      }

      .color-red {
        background: #F56D6D;
      }

      .color-gray {
        background: #8C8F95;
      }
    }

    // 表格
    .table {
      width: calc(100% - 40px);
      margin-top: 18px;

      .main {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        padding: 5px;
        color: #909399;

        .item {
          width: 50%;
          padding: 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .label {
            width: 50%;
            margin-left: -15px;
            font-size: 14px;
          }

          .value {
            width: 80%;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
<template>
  <div class="production-monthly">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt">
    </yi_curd_table>
    <div class="panel">
      <!-- 信息说明 -->
      {{$t('meiri9:00gengxinzuorishuju')}}
    </div>
    <!-- 表单 -->
    <div class="form">
      <div ref="search1">
        <el-form style="height: 28px;" :model="equipmentProduction.searchForm" :inline="true" size="mini">
          <el-form-item :label="$t('tongjishijian')">
            <el-date-picker v-model="equipmentProduction.searchForm.reportDateStr" :clearable="false"
              @change="handleChange"
              value-format="yyyyMM" format="yyyy年MM" type="month" :placeholder="$t('xuanzeyuefen')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('xiaoluzhibiao')">
            <el-select v-model="equipmentProduction.searchForm.type" @change="$forceUpdate()">
              <el-option :label="$t('kaijilu')" :value="1"></el-option>
              <el-option :label="$t('jiadonglu')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getEquipmentBasicReport" plain>
              {{$t('sousuo')}}
            </el-button>
            <el-button type="default" @click="resetEquipmentProduction" plain style="margin-left: 10px;">
              {{$t('chongzhi')}}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 详细指标 -->
    <div class="detail-target">
      <div class="left">
        <!--        <span class="icon"></span>-->
        <!--        <span class="txt">{{$t('xiangxizhibiao')}}</span>-->
        <!--筛选设备-->
        <!--        <span class="txt">-->
        <!--          <el-button type="primary" size="mini"  @click="setUp" plain>{{$t('shaixuanshebei')}}</el-button>-->
        <!--        </span>-->

      </div>
      <div class="right">
        <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')"
          @click="exportBasicProductionExcel()">
        </el-button>
        <el-button size="mini" type="default" @click="showShowTableColumn('equipmentProduction')"><i
          class="yicon yicon-config_column"></i>
        </el-button>
      </div>
    </div>
    <!-- 图表和表单 -->
    <div class="echart-table">
      <div class="table">
        <el-table max-height="600" stripe :data="equipmentProduction.tableData" border size="mini" v-loading="searchLoading"
          :row-style="{height:42+'px'}" :cell-style="{padding:0+'px'}"
          :header-cell-style="{background: '#F5F7FA', color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
          :show-overflow-tooltip="true" @header-dragend="headerDragend">
          <el-table-column :show-overflow-tooltip="true"
            v-for="(item, index) in filterEquipmentProductionTableColumn" :key="index" :prop="item.prop"
            :fixed="item.fixed" :label="$t(item.label)" :sortable="item.sortable" :width="item.width">
            <template slot-scope="scope">
							<span v-if="!['orgName', 'shiftName', 'equipmentName'].includes(item.prop)"
                style="color: #419FFF"
              >{{scope.row[item.prop]}}</span>
              <span v-else style="color: #606266">{{scope.row[item.prop]}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right; margin-top:8px">
          <el-pagination class="fy" layout="total,prev, pager, next,sizes"
              :current-page="equipmentProduction.currentPage" @size-change="handleSizeChange"
              @current-change="handleCurrentChange" @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange" :total="parseInt(equipmentProduction.total)"
              :page-sizes="[10, 20, 100, 500]" :pagerCount="5" background>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'chanpinxiangqing'">
        <div class="dialog-scroller">
          <product_details :details="yt.editObj" :start="startTimes"></product_details>
        </div>
      </template>
    </el-dialog>
    <!-- 自定义显示项 -->
    <el-dialog :title="$t(showTableColumn.title)" :visible.sync="showTableColumn.dialog" width="720px">
      <!-- 产品月报 -->
      <template v-if="showTableColumn.type === 'equipmentProduction'">
        <el-transfer :titles="[$t('yincanglie'), $t('xianshilie')]"
          v-model="showTableColumn.equipmentProduction.show" :format="{
          noChecked: '${total}',
          hasChecked: '${total}'
        }" :data="equipmentProduction.tableColumn">
          <span slot-scope="{ option }"> {{$t(option.label)}}</span>
        </el-transfer>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
// import product_details from '@@/pages/web/report/mes_produce_report/mes_production/mes_tabs/product_details_one'

const date = new Date()
const year = date.getFullYear()
const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
const current = year + '-' + month

const startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01'
const endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
export default {
    name: "web_report_efficiency_report_daily_statistics",
    props: {
        selectEquipment: {
            type: Array,
            required: true
        },
    },
    components: {
        // product_details
    },

    data() {
      return {
        searchLoading: false,
        exportLoading: false,
        type: null,
        years: null,
        dates: null,
        allMonth: null,
        monthDate: null,
        monthDay: null,
        startTimes: '',
        currentStart: '',
        currentEnd: '',
        chartValueData: [],
        chartHeight2: 120,
        fildIds: '',
        timer: null,
        chart: null,
        options2: null,
        statusColors: {
            "0": "#67C23A",
            "3": "#F56C6C",
            "1": "#E6A23C",
            "-1": "#909399",
        },
        show: true,
        activeName: 'second',
        // 产量月报
        equipmentProduction: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
            searchForm: {
                reportDateStr: '',
                type: '',
            },
            tableData: [],
            tableColumn: [{
                label: this.$t("shebeimingcheng"),
                prop: 'equipmentName',
                width: "160",
                sortable: true,
                key: 0,
                fixed: true,
            }, {
                label: this.$t("suoshuzuzhi"),
                prop: 'orgName',
                width: "150",
                key: 1,
                fixed: true,
            }
            ],

        },
        // 产品详情
        productionDetail: {
            dialog: false,
            direction: 'rtl',
            title: this.$t('chanliangxiangqing'),

            tableColumn: [{
                label: 'muhao',
                prop: 'mould',
                width: 150
            },
                {
                    label: 'kaishishijian',
                    prop: 'startTime',
                    width: 150
                },
                {
                    label: 'jieshushijian',
                    prop: 'endTime',
                    width: 150
                },
                {
                    label: 'dangbanchanliang',
                    prop: 'shiftProduction',

                }
            ],
            tableData: [],
            info: {
                sn: '',
                time: '',
                shiftName: '',
                runDuration: '', // 运行时间
                idleDuration: '',
                errorDuration: '',
                shutdownDuration: ''
            }
        },
        showTableColumn: {
            dialog: false,
            title: 'peizhixianshilie',
            type: 'equipmentProduction',
            // 产品月报
            equipmentProduction: {
                show: [0, 1, 2],
                initShow: [],
            },
        },
      }
    },
    computed: {
        filterEquipmentProductionTableColumn() {
            let tableColumn = []
            for (let i = 0; i < this.equipmentProduction.tableColumn.length; i++) {
                if (this.showTableColumn.equipmentProduction.show.includes(this.equipmentProduction.tableColumn[i][
                    'key'
                    ])) {
                    tableColumn.push(this.equipmentProduction.tableColumn[i])
                }
            }
            const name = 'producee_report_second'
            let colwidths = {}
            if (window.localStorage.getItem("colwidth_" + name)) {
                try {
                    colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name))
                } catch (e) {
                    window.localStorage.removeItem("colwidth_" + name)
                }
            }
            if (tableColumn.length > 0) {
                for (const i in tableColumn) {
                    if (colwidths[this.$t(tableColumn[i]['label'])] !== undefined) {
                        this.$set(tableColumn[i], 'width', colwidths[this.$t(tableColumn[i]['label'])])
                    }
                }
            }
            return tableColumn
        },
    },
    created() {
        const year = String(date.getFullYear())
        const month = String((date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1))
        this.equipmentProduction.searchForm.reportDateStr = year + month
        console.log('kkkkk', this.equipmentProduction.searchForm.reportDateStr)
        this.equipmentProduction.searchForm.type = 1
        this.getEquipmentBasicReport();
    },
    mounted() {
        this.resize()
        this.utils.event_hub.$on('RESIZE', () => {
            this.resize();
        });
    },
    activated() {
        this.resize()
    },
    destroyed() {
        clearTimeout(this.timer)
    },
    watch: {
        selectEquipment: {
            handler(n) {
                this.getEquipmentBasicReport()
            },
            immediate: false,
            deep: true
        }
    },
    methods: {
      handleCurrentChange(value) {
        this.equipmentProduction.currentPage = value;
        this.getEquipmentBasicReport()
      },
      handleSizeChange(value) {
        this.equipmentProduction.pageSize = value;
        this.getEquipmentBasicReport()
      },
      handleChange2(value, direction, movedKeys) {
          if (direction === "right") {
              this.equipmentId = movedKeys + ''
              console.log('type3', this.equipmentId)
          }
      },

      handleChange(val) {
          this.allMonth = val
          console.log('val111', val)
      },
      getMonthLength(date) {
          const aad = date
          console.log('11111date', date)
          let d = new Date(date)
          // 将日期设置为下月一号
          d.setMonth(d.getMonth() + 1)
          d.setDate('1')
          // 获取本月最后一天
          d.setDate(d.getDate() - 1)
          return d.getDate()
      },
      getIsMonthHas31Days(year, month) {
          let nextMonthFirstDay = new Date(year, month, 1);
          let currentMonthFirstDay = new Date(year, month - 1, 1);
          let diffTime = nextMonthFirstDay - currentMonthFirstDay;
          let diffDays = diffTime / (24 * 60 * 60 * 1000);
          return diffDays === 31;
      },
      //判断某年某月是否有31天
      getEquipmentBasicReport() {
        this.searchLoading = true;
        let str = this.selectEquipment.join(',')
        // this.show = false
        this.equipmentProduction.tableColumn = [{
            label: 'shebeimingcheng',
            prop: 'equipmentName',
            width: "160",
            sortable: true,
            fixed: true,
            key: 0,
        }, {
            label: 'suoshuzuzhi',
            prop: 'orgName',
            width: "150",
            sortable: false,
            fixed: true,
            key: 1,
        }
        ]
        this.monthDay = this.equipmentProduction.searchForm.reportDateStr.slice(-2)
        const maxDay = this.getMonthLength(this.equipmentProduction.searchForm['reportDateStr'])
        if (this.equipmentProduction.searchForm.type == 1) {
            this.type = 'startup_rate'
        } else {
            this.type = 'run_rate'
        }
        let params = {
          pageSize: this.equipmentProduction.pageSize,
          pageNum: this.equipmentProduction.currentPage,
            month: this.equipmentProduction.searchForm.reportDateStr,
            equipmentId: str,
            type: this.type,
            orderBy: 'sort asc'
        }
        for (const i in params) {
            if (params[i] === '' || params[i] === null || params[i] === undefined) {
                delete params[i]
            }
        }
        return this.http.get('/web/report/page/xiaolvbaobiao_ritongji?' + this.qs.stringify(params)).then(res => {
          this.equipmentProduction.tableData = res.data.rows
          this.equipmentProduction.total = res.data.total
          if (this.equipmentProduction.tableData.length > 0) {
            let reses = this.equipmentProduction.tableData[0]
            let month = this.monthDay

            let column = []
            let key = 3
            for (let i in reses) {
                if (/^date/.test(i)) {
                    if (i.substr(4) > maxDay) {
                        continue
                    }
                    column.push({
                        key: key,
                        label: month + '/' + i.substr(4),
                        prop: i,
                        num: parseInt(i.substr(4)),
                        width: "90",
                        sortable: true
                    })
                    this.showTableColumn.equipmentProduction.show.push(key)
                    console.log('ass', reses.years)
                    ++key
                }
            }
            this.showTableColumn.equipmentProduction.initShow = [...this.showTableColumn.equipmentProduction
                .show
            ]
            column.sort(this.sortData)
            for (let i = 0; i < column.length; i++) {
                this.equipmentProduction.tableColumn.push(column[i])
            }
          } else {
            let key = 2
            // 补充列
            const year = this.equipmentProduction.searchForm.reportDateStr.slice(0,4)
            const selectDate = this.getIsMonthHas31Days(year,this.monthDay)
            const dateColumn = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12','13','14','15',
                '16','17','18','19','20','21','22','23','24','25','26','27','28','29','30']
            const dateColumnTwo = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12','13','14','15',
                '16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']
            if(selectDate===true){
                dateColumnTwo.forEach(item => {
                    this.equipmentProduction.tableColumn.push({
                        key: key,
                        label: this.monthDay + '/' + item,
                        prop: 'date' + item,
                        width: "110",
                        sortable: true
                    })
                    ++key
                })
            }else {
                dateColumn.forEach(item => {
                    this.equipmentProduction.tableColumn.push({
                        key: key,
                        label: this.monthDay + '/' + item,
                        prop: 'date' + item,
                        width: "110",
                        sortable: true
                    })
                    ++key
                })
            }
          }
        }).finally(() => {
          this.searchLoading = false;
        });
      },
      // 排序
      sortData(a, b) {
          return a.num - b.num
      },
      // 产量月报基础表导出
      exportBasicProductionExcel() {
        this.exportLoading = true;
        if (this.equipmentProduction.searchForm.type == 1) {
          this.type = 'startup_rate'
        } else {
          this.type = 'run_rate'
        }
        let str = this.selectEquipment.join(',');
        let requestParam = {
          month:this.equipmentProduction.searchForm.reportDateStr,
          type: this.type,
          equipmentId:str,
        }

        for (const i in requestParam) {
            if (requestParam[i] === '' || requestParam[i] === null || requestParam[i] === undefined) {
                delete requestParam[i]
            }
        }
        return this.http.get('/web/report/export/xiaolvbaobiao_ritongji?' + this.qs.stringify(requestParam)).then(response => {
          let fildId = response.data
          // this.$message.success(this.$t(response.msg))
          return this.http.get('/web/report/work/get', {
              params: {
                  id: fildId
              }
          }).then(response => {
              this.fildIds = response.data.fileId
              console.log('response.msg1', response.data.status)
              let status = response.data.status
              if (status == 1) {
                  this.getDownload()
                  this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
                  this.$message.success(this.$t(response.msg))
              } else if (status == -1) {
                  this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
                  this.$message.success(this.$t(response.msg))
              } else if (status == 0 || null) {
                  this.timer = setInterval(() => {
                      this.getDownload()
                  }, 1000)
              }
          }).finally(() => {
            this.exportLoading = false;
          });
        }).catch(error => {
          this.$message.error(this.$t(error))
        }).finally(() => {
          this.exportLoading = false;
        });
      },
        getDownload() {
            console.log('this.fildIdthis.fildId', this.fildIds)
            return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
                let baseUrl = res.data
                if (res.data) {
                    window.open(baseUrl)
                }
            })
        },
        //  重置产量月报
        resetEquipmentProduction() {
            const year = String(date.getFullYear())
            const month = String((date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1))
            this.equipmentProduction.searchForm.reportDateStr = year + month
            this.getEquipmentBasicReport()
        },
        resize() {
            //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
            setTimeout(() => {
                this.screenWidth = document.body.clientWidth
                if (this.produceeReportChart != null) {
                    this.produceeReportChart.resize()
                }
                if (this.reportChart != null) {
                    this.reportChart.resize()
                }
                if (this.chart != null) {
                    this.chart.resize()
                }
            }, 500)
        },
        // 显示选择项
        showShowTableColumn(type) {
            this.showTableColumn.type = type
            this.showTableColumn.dialog = true
        },
        // 取消选择项
        cancelShowTableColumn() {
            this.showTableColumn.show = [...this.showTableColumn.initShow]
            this.showTableColumn.dialog = false
        },
        headerDragend(newWidth, oldWidth, column, event) {
            console.log('ddddasa', this.activeName)
            const name = 'producee_report_' + this.activeName
            let colwidths = {}
            if (window.localStorage.getItem("colwidth_" + name)) {
                try {
                    colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name))
                } catch (e) {
                    window.localStorage.removeItem("colwidth_" + name)
                }
            }
            if (column.label == "" || column.label == null) {
                return
            }
            colwidths[column.label] = column.width
            window.localStorage.setItem("colwidth_" + name, JSON.stringify(colwidths))
        },
        // 打开产品详情弹框
        // showProductionDetail(row, date){
        //     // console.log('rowssss',row)
        //     this.startTimes= row.reportDateYear + '-' + row.reportDateMonth + '-' + date.substr(date.length - 2)
        //     this.yt.showEditDialog('chanpinxiangqing', row, '80%');
        // },
        // 日期转换
        dateFormat(time) {
            const t = new Date(time)
            // 日期格式
            const format = 'Y-m-d h:i:s'
            let year = t.getFullYear()
            // 由于 getMonth 返回值会比正常月份小 1
            let month = t.getMonth() + 1
            let day = t.getDate()
            let hours = t.getHours()
            let minutes = t.getMinutes()
            let seconds = t.getSeconds()
            month = month > 9 ? month : `0${month}`
            day = day > 9 ? day : `0${day}`
            hours = hours > 9 ? hours : `0${hours}`
            minutes = minutes > 9 ? minutes : `0${minutes}`
            seconds = seconds > 9 ? seconds : `0${seconds}`
            const hash = {
                'Y': year,
                'm': month,
                'd': day,
                'h': hours,
                'i': minutes,
                's': seconds
            }
            return format.replace(/\w/g, o => {
                return hash[o]
            })
        },
        dateItemFormat(time) {
            const t = new Date(time)
            // 日期格式
            const format = 'Y-m-d'
            let year = t.getFullYear()
            // 由于 getMonth 返回值会比正常月份小 1
            let month = t.getMonth() + 1
            let day = t.getDate()
            month = month > 9 ? month : `0${month}`
            day = day > 9 ? day : `0${day}`
            const hash = {
                'Y': year,
                'm': month,
                'd': day,
            }
            return format.replace(/\w/g, o => {
                return hash[o]
            })
        },
    }
}
</script>
